import React from 'react';
import { ArrowRight, Award, Users, ShieldCheck } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="relative py-24 lg:py-36 bg-ink text-ivory overflow-hidden">
      {/* Decorative gold lines */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gold/30"></div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gold/30"></div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          {/* Left: Images */}
          <div className="lg:col-span-5 relative">
            <div className="img-zoom aspect-[4/3] relative shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_premium-services-hub-10/artifacts/ev29wruh_WhatsApp%20Image%202026-07-01%20at%2012.38.42%20PM%20%282%29.jpeg"
                alt="KMH & Associates team - Bengaluru"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 border border-ivory/10 pointer-events-none"></div>
            </div>
            {/* Caption plate */}
            <div className="absolute -bottom-8 left-6 lg:left-10 bg-ivory px-6 py-4 border-l-2 border-gold shadow-xl">
              <p className="font-mono-label text-gold-dark">The KMH Team</p>
              <p className="font-serif-display text-xl text-ink mt-1">Bengaluru · Est. 2020</p>
            </div>
            {/* Accent */}
            <div className="absolute -top-6 -left-6 hidden md:block">
              <div className="w-32 h-32 border border-gold/40 rounded-full flex items-center justify-center">
                <span className="font-serif-display italic text-gold-soft text-2xl">est.2020</span>
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div className="lg:col-span-6 lg:col-start-7">
            <div className="flex items-center gap-4 mb-6">
              <span className="gold-divider"></span>
              <span className="font-mono-label text-gold-soft">About KMH</span>
            </div>
            <h2 className="font-serif-display text-4xl lg:text-[3.4rem] leading-[1.08]">
              Beyond compliance.
              <br />
              <span className="italic text-gold-soft">A holistic </span>advisory partnership.
            </h2>
            <p className="font-sans-body text-lg text-ivory/75 leading-relaxed mt-8">
              Founded in 2020, KMH &amp; Associates is a professional and trusted company secretarial and business
              advisory firm that has empowered <em>more than 500</em> businesses of all shapes and sizes across
              diverse industries. Our team — composed of highly qualified and experienced Company Secretaries
              — is committed to providing the complete arc of advisory services.
            </p>
            <p className="font-sans-body text-base text-ivory/65 leading-relaxed mt-5">
              From secretarial compliance to fundraising, PoSH to FEMA, NBFC to LLP, and beyond — we address
              every business need. Our goal is to give our clients ease of life and business, and to achieve that,
              we go far beyond mere compliance.
            </p>

            {/* Pillars */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-12">
              {[
                { icon: ShieldCheck, label: 'Bullet-Proof Frameworks' },
                { icon: Users, label: 'Senior-Led Engagements' },
                { icon: Award, label: 'Defensible Outcomes' },
              ].map((p) => (
                <div key={p.label} className="border-t border-gold/30 pt-5 group">
                  <p.icon className="w-7 h-7 text-gold-soft" strokeWidth={1.2} />
                  <p className="font-serif-display text-lg mt-3 text-ivory">{p.label}</p>
                </div>
              ))}
            </div>

            <a
              href="#services"
              className="inline-flex items-center gap-4 mt-12 font-mono-label text-ivory group"
            >
              <span>Discover Our Approach</span>
              <span className="w-12 h-12 rounded-full border border-gold/50 group-hover:bg-gold group-hover:border-gold flex items-center justify-center">
                <ArrowRight className="w-4 h-4 text-ivory" />
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
